export default "__VITE_ASSET__Cwp220qn__"